import { inject, Injectable } from "@angular/core";

import { from, Observable } from "rxjs";
import { BeUsersService } from "src/app/services/business/user-services/be-users.service";

@Injectable({
  providedIn: "root",
})
export class RolesResolver {
  private service = inject(BeUsersService);

  resolve(): Observable<string[]> {
    return from(this.service.loadRoles());
  }
}
